import Masthead from "./components/Masthead";
import Ticker from "./components/Ticker";
import FirstScreen from "./components/FirstScreen";
import TodayTalk from "./components/TodayTalk";
import PeopleArchive from "./components/PeopleArchive";
import QuickFeed from "./components/QuickFeed";
import Timeline from "./components/Timeline";
import ArchiveZone from "./components/ArchiveZone";
import TopRank from "./components/TopRank";
import DownloadCta from "./components/DownloadCta";
import SubscribeCta from "./components/SubscribeCta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Masthead />
      <Ticker />
      <main>
        <FirstScreen />
        <TodayTalk />
        <PeopleArchive />
        <QuickFeed />
        <Timeline />
        <ArchiveZone />
        <TopRank />
        <DownloadCta />
        <SubscribeCta />
      </main>
      <Footer />
    </div>
  );
}